import React from 'react';
import ReactDOM from 'react-dom';
import { universal } from '../components/loadable';

export const LoadableCourseProgressBar = universal(
  import(
    /* webpackChunkName: 'CourseProgressBar' */ './ConnectedCourseProgressBar'
  ),
  {
    key: 'HotConnectedCourseProgressBar',
  }
);

export const CourseProgressBarPortal = () => {
  const elem = document.getElementById('course-progress-bar-container');
  if (elem) {
    return ReactDOM.createPortal(<LoadableCourseProgressBar />, elem);
  } else {
    return null;
  }
};
